import { useContext } from 'react'
import { useQuery } from 'react-query'
import { apiGet } from 'api'
import AuthContext from 'context/auth-context'
import UserContext from 'context/user-context'

const getMunicipalityUsers = async (token, municipalityId, sectionId) => {
  const url = `municipalities/${municipalityId}/users`
  const params = sectionId ? { section_id: sectionId } : {}
  const data = await apiGet({ url, token, params })
  return data
}

export default function useMunicipalityUsers({ sectionId, options }) {
  const { municipality_id } = useContext(UserContext)
  const token = useContext(AuthContext)
  const queryFn = () => getMunicipalityUsers(token, municipality_id, sectionId)
  const queryKey = sectionId ? ['municiality_users', sectionId] : 'municiality_users'
  return useQuery(queryKey, queryFn, { ...options })
}
